export default {
  params: ['claimTypesCounters'],
  validate: (value, { claimTypesCounters }) => {
    if (!claimTypesCounters) return true;

    const maxAmountOfType = 5;
    const message = `You can't select more than ${maxAmountOfType} claims of this type`;

    for (const key in claimTypesCounters) {
      if (key === value && claimTypesCounters[key] >= maxAmountOfType) {
        return message;
      }
    }

    return true;
  },
};
